import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Activity, Lock, Mail } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card } from "../components/ui/card";
import { toast } from "sonner";
import apiClient from "../lib/apiClient"; // 🔥 Centralized client import kiya

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // 🔥 Dynamic calling without hardcoding the domain URL
      const response = await apiClient.post("/login", { email, password });
      
      const { token, role, name } = response.data;
      
      login({ email, role, name }, token);
      toast.success("Welcome back!");
      
      navigate(role === "admin" ? "/upload" : "/rrg");

    } catch (err) {
      if (err.response?.data?.unverified) {
         toast.error("Email not verified. Please check your inbox for OTP.");
      } else {
         toast.error(err.response?.data?.message || "Invalid Credentials");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-md p-8 shadow-2xl border-0 bg-white rounded-2xl">
        <div className="flex flex-col items-center mb-8">
          <div className="bg-sky-100 p-3 rounded-2xl mb-4">
            <Activity className="w-8 h-8 text-sky-600" />
          </div>
          <h1 className="text-2xl font-black text-slate-900 tracking-tight">Access QuantRRG</h1>
          <p className="text-slate-500 text-sm font-medium mt-1">Enter your credentials to continue</p>
        </div>

        <form onSubmit={handleLogin} className="space-y-5">
          <div className="space-y-2">
            <Label className="text-xs font-bold text-slate-500 uppercase tracking-widest">Email Address</Label>
            <div className="relative">
              <Mail className="w-4 h-4 absolute left-3 top-3 text-slate-400" />
              <Input type="email" placeholder="email@example.com" value={email} onChange={(e) => setEmail(e.target.value)} className="pl-10 h-10 font-medium bg-slate-50 border-slate-200" required />
            </div>
          </div>

          <div className="space-y-2">
            <Label className="text-xs font-bold text-slate-500 uppercase tracking-widest">Password</Label>
            <div className="relative">
              <Lock className="w-4 h-4 absolute left-3 top-3 text-slate-400" />
              <Input type="password" placeholder="••••••••" value={password} onChange={(e) => setPassword(e.target.value)} className="pl-10 h-10 font-medium bg-slate-50 border-slate-200" required />
            </div>
            <Link to="/forgot-password" className="text-[11px] font-bold text-sky-600 hover:underline">
                Forgot password?
            </Link>
          </div>

          <Button type="submit" disabled={loading} className="w-full h-12 bg-slate-900 hover:bg-slate-800 text-white font-bold shadow-lg mt-2">
            {loading ? "Authenticating..." : "Secure Login"}
          </Button>
        </form>

        <p className="text-center text-sm font-medium text-slate-500 mt-6">
          Don't have an account? <Link to="/register" className="text-sky-600 font-bold hover:underline">Register here</Link>
        </p>
      </Card>
    </div>
  );
}